import { render, staticRenderFns } from "./new-list.vue?vue&type=template&id=222a58c6&scoped=true&"
import script from "./new-list.vue?vue&type=script&lang=js&"
export * from "./new-list.vue?vue&type=script&lang=js&"
import style0 from "./new-list.vue?vue&type=style&index=0&id=222a58c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a58c6",
  null
  
)

export default component.exports